import { MediaQuery } from 'foundation-sites/js/foundation.util.mediaQuery'
import Awesomplete from 'awesomplete'
import debounce from 'lodash-es/debounce'
import EventBus from 'event_bus'
import jump from 'jump.js-cancelable'

export default class Typeahead {
  constructor (id) {
    this.input = document.getElementById(id)

    if (!this.input) { return }

    this.currentSuggestion = null

    this.awesomplete = new Awesomplete(
      this.input,
      {
        filter: Awesomplete.FILTER_STARTSWITH,
        maxItems: 5,
        sort: false
      }
    )

    this.input.addEventListener('awesomplete-highlight', event => {
      this.currentSuggestion = event.text
      this.awesomplete.replace(event.text)
    })

    this.input.addEventListener('awesomplete-selectcomplete', () => {
      EventBus.trigger('ontology_light_typeahead:select')
    })

    this.input.addEventListener('click', () => {
      this.awesomplete.evaluate()
    })

    this.input.addEventListener('focus', debounce(() => {
      if (MediaQuery.is('small only')) {
        jump.jump(this.input, { offset: -24 })
      }
      this.awesomplete.evaluate()
    }))
  }
}
